import CrudRequest from '@rootCommon/services/crud-request';
import { DASHBOARD_BRANDING_RECORD } from '@rootCommon/constants/end-points';
import { ADMIN } from '@rootCommon/constants/common';
import { DashboardBranding, DashboardBrandingDto } from '@rootCommon/types/branding';

const DASHBOARD_BRANDING_ADMIN = `https://medicine-dashboard.pages.dev/auth/login`;

class DashboardBrandingService extends CrudRequest<DashboardBranding, DashboardBrandingDto> {
  constructor() {
    super(DASHBOARD_BRANDING_ADMIN);
  }

  get = async (): Promise<DashboardBranding> => {
    const res = await CrudRequest.get<DashboardBranding>(DASHBOARD_BRANDING_ADMIN);

    return res.data;
  };
}

export default new DashboardBrandingService();
